import { render, staticRenderFns } from "./SlotTest.vue?vue&type=template&id=45830084&scoped=true&"
import script from "./SlotTest.vue?vue&type=script&lang=js&"
export * from "./SlotTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45830084",
  null
  
)

export default component.exports